import ReaderStatus from './ReaderStatus';
import InformationCard from './InformationCard';

const Information = ({ paymentKind, cardMessage, amount, status }) => {
  if (paymentKind === 'saved-cards')
    return <ReaderStatus status={status} amount={amount} message={cardMessage} />;

  return (
    <InformationCard
      icon="illustration-credit-card"
      title="Enter your card details"
      description="You can also tap or insert your card on the reader or use a saved card."
    />
  );
};

export default Information;
